// extracted by mini-css-extract-plugin
export var bounce = "_kv-1";
export var generatingText = "_kv-6";
export var lightning = "_kv-4";
export var popup = "_kv-5";
export var progressBar = "_kv-7";
export var progressFill = "_kv-8";
export var progressShimmer = "_kv-9";
export var progressText = "_kv-a";
export var shimmer = "_kv-3";
export var uploadIcon = "_kv-0";
export var uploadingText = "_kv-2";